<template>
  <v-layout column>
    <v-flex xs12 md12>
      <v-toolbar style="background-color: white !important">
        <v-btn icon @click="toPage('/account/')">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <h2>ตอบกลับข้อความอัตโนมัติ</h2>
      </v-toolbar>
    </v-flex>
    <div>
      <v-tabs
        slot="extension"
        v-model="tabs"
        fixed-tabs
        color="transparent"
        icons-and-text
        centered
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1" :key="1">
          ตั้งเวลาตอบกลับข้อความ
          <v-icon style="font-size: 25px !important; color: #607d8b !important"
            >chat</v-icon
          >
        </v-tab>
        <v-tab href="#tab-2" :key="2">
          รายการทั้งหมด
          <v-icon style="font-size: 25px !important; color: #607d8b !important"
            >fas fa-file</v-icon
          >
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs" class="white elevation-1">
        <v-tab-item
          id="tab-1"
          style="height: calc(100vh - 200px)"
          class="scrolling-wrapper"
        >
          <v-card-text>
            <v-container
              style="
                justify-content: left !important;
                height: calc(100vh - 140px);
              "
              class="scrolling-wrapper"
            >
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 md12>
                  <v-textarea
                    v-model="message.message"
                    solo
                    name="input-7-4"
                    label="ข้อความที่ต้องการส่ง..."
                    style="color: white !important"
                    hide-details
                  ></v-textarea>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-radio-group v-model="daySent" row class="justify-center">
                      <v-radio
                        label="ส่งทุกวัน (จ.-อา.)"
                        value="everyday"
                      ></v-radio>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <v-radio label="ส่งบางวัน" value="someday"></v-radio>
                    </v-radio-group>
                  </v-layout>
                </v-flex>
                <div v-if="daySent === 'everyday'" class="Everyday">
                  <v-flex style="padding-bottom: 10px">
                    <span style="padding-left: 2em; font-weight: bold"
                      >เวลาที่ต้องการส่ง:
                    </span>
                  </v-flex>
                  <div
                    style="
                      padding-left: 20px;
                      padding-right: 20px;
                      padding-top: 16px;
                    "
                  >
                    <date-picker
                      style="padding-left: 2em"
                      v-model="days[0].start"
                      placeholder="เลือกเวลา"
                      format="HH:mm"
                      type="time"
                    >
                      <template slot="icon-calendar">
                        <i class="" aria-hidden="true"></i>
                      </template>
                    </date-picker>
                    &nbsp; - &nbsp;
                    <date-picker
                      v-model="days[0].end"
                      placeholder="เลือกเวลา"
                      format="HH:mm"
                      type="time"
                    >
                      <template slot="icon-calendar">
                        <i class="" aria-hidden="true"></i>
                      </template>
                    </date-picker>
                  </div>
                </div>

                <div v-else class="box">
                  <v-flex style="padding-bottom: 10px">
                    <span style="font-weight: bold">เวลาที่ต้องการส่ง: </span>
                  </v-flex>
                  <div v-for="item in days" :key="item.val">
                    <v-layout row wrap>
                      <v-checkbox
                        v-model="item.selected"
                        :label="item.text"
                        hide-details
                      ></v-checkbox>
                      <date-picker
                        style="padding-left: 2em; padding-top: 16px"
                        v-model="item.start"
                        placeholder="เลือกเวลา"
                        format="HH:mm"
                        type="time"
                      >
                        <template slot="icon-calendar">
                          <i class="" aria-hidden="true"></i>
                        </template>
                      </date-picker>
                      &nbsp;
                      <span
                        style="
                          padding-top: 20px;
                          padding-left: 10px;
                          padding-right: 10px;
                        "
                        >-</span
                      >
                      &nbsp;
                      <date-picker
                        style="padding-top: 16px"
                        v-model="item.end"
                        placeholder="เลือกเวลา"
                        format="HH:mm"
                        type="time"
                      >
                        <template slot="icon-calendar">
                          <i class="" aria-hidden="true"></i>
                        </template>
                      </date-picker>
                    </v-layout>
                  </div>
                </div>
                <v-flex xs12 sm12 md12 style="padding-top: 12px">
                  <v-btn
                    round
                    @click="submit"
                    color="#607d8b"
                    style="color: white"
                    :disabled="disableButton"
                    >บันทึก</v-btn
                  >
                  <v-btn round @click="clear()">ยกเลิก</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-tab-item>

        <v-tab-item id="tab-2" style="height: calc(100vh - 200px); " class="scrolling-wrapper" >
          <v-data-table
            :headers="headers"
            :items="list_messsage_reply"
            class="elevation-1 ma-5"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                {{ formatDate(props.item.createddate) }}
              </td>
              <td class="text-xs-center">{{ props.item.message }}</td>
              <td class="pt-3">
                <p v-for="(day,index) in props.item.businessdays" :key="index">
                  {{day.description}}
                </p>
              </td>
              <td class="text-xs-center pt-3">
                <p v-for="(day,index) in props.item.businessdays" :key="index">
                  {{day.opentime}}
                </p>
              </td>
              <td class="text-xs-center pt-3">
                <p v-for="(day,index) in props.item.businessdays" :key="index">
                  {{day.beforetime}}
                </p>
              </td>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-layout>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
var _ = require('lodash')
export default {
  components: {
    DatePicker
  },
  data: () => ({
    headers: [
      {
        text: 'วันที่สร้าง',
        sortable: false,
        value: 'create_date',
        align: 'center'
      },
      { text: 'ข้อความ', sortable: false, value: 'type', align: 'center' },
      { text: 'วันที่ส่ง', sortable: false, value: 'type', align: 'center' },
      {
        text: 'เวลาเริ่มต้น',
        sortable: false,
        value: 'type_message',
        align: 'center'
      },
      {
        text: 'เวลาสิ้นสุด',
        sortable: false,
        value: 'message',
        align: 'center'
      }
    ],
    list_messsage_reply: [],
    list_date_reply: [],
    tabs: 'tab-1',
    daySent: 'everyday',
    days: [
      {
        selected: false,
        day: 1,
        text: 'วันจันทร์',
        val: 'Monday',
        start: null,
        end: null
      },
      {
        selected: false,
        day: 2,
        text: 'วันอังคาร',
        val: 'Tuesday',
        start: null,
        end: null
      },
      {
        selected: false,
        day: 3,
        text: 'วันพุธ',
        val: 'Wednesday',
        start: null,
        end: null
      },
      {
        selected: false,
        day: 4,
        text: 'วันพฤหัสบดี',
        val: 'Thursday',
        start: null,
        end: null
      },
      {
        selected: false,
        day: 5,
        text: 'วันศุกร์',
        val: 'Friday',
        start: null,
        end: null
      },
      {
        selected: false,
        day: 6,
        text: 'วันเสาร์',
        val: 'Saturday',
        start: null,
        end: null
      },
      {
        selected: false,
        day: 0,
        text: 'วันอาทิตย์',
        val: 'Sunday',
        start: null,
        end: null
      }
    ],
    message: {
      message: '',
      status: 1,
      descriptionstatus: ''
    }
  }),
  created () {
    this.getListautoreply()
    const str = '22:20:00'
    const str2 = '08:20:00'
    console.log(parseInt(str.slice(0, 2)) > parseInt(str2.slice(0, 2)))
    // var time1 = new Date()
    // var time2 = new Date()
  },
  watch: {
    daySent () {
      this.days.forEach((day) => {
        day.selected = false
        day.start = null
        day.end = null
      })
    }
  },
  computed: {
    disableButton () {
      const { daySent, days, message } = this

      if (!message.message) {
        return true
      } else {
        if (daySent === 'everyday') {
          if (days[0].start && days[0].end) {
            return false
          } else {
            return true
          }
        } else {
          const selectedDays = days.filter((day) => day.selected)

          if (selectedDays.length === 0) {
            return true
          } else {
            return !selectedDays.every((day) => day.start && day.end)
          }
        }
      }
    }
  },
  methods: {
    toPage (data) {
      this.$router.push(data + this.$route.params.id)
    },
    submit () {
      const body = this.getBody()
      // console.log(body)
      this.axios
        .post(
          process.env.VUE_APP_API_CHECK_AUTOREPLY + '/insertbusinessday',
          body
        )
        .then((response) => {
          if (response.data.message === 'success') {
            this.$swal({
              title: 'บันทึกสำเร็จ',
              type: 'success'
            }).then((value) => {
              if (value) {
                this.clear()
                this.getListautoreply()
              }
            })
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    getBody () {
      var { message } = this // ก้อน message
      var botid = this.$route.params.id
      var days
      if (this.daySent === 'everyday') {
        days = this.days
      } else {
        days = this.days.filter((item) => item.selected)
      }

      var businessday = days.map((day) => {
        const openTime = this.daySent === 'everyday' ? days[0].start : day.start
        const closeTime = this.daySent === 'everyday' ? days[0].end : day.end
        const sameDay = (+closeTime) - (+openTime) > 0

        const data = {
          day: day.day,
          description: day.val,
          opentime: this.formatTime(openTime),
          closetime: sameDay ? this.formatTime(closeTime) : '23:59:59',
          status: 1,
          beforetime: sameDay ? this.formatTime(closeTime) : this.formatTime(closeTime),
          aftertime: sameDay ? this.formatTime(openTime) : '23:59:59'
        }

        return data
      })

      var body = {
        botid,
        businessday,
        message
      }
      return body
    },
    clear () {
      this.daySent = 'everyday'
      this.days.forEach((day) => {
        day.selected = false
        day.start = null
        day.end = null
      })
      this.message.message = ''
    },
    getListautoreply () {
      this.axios
        .get(
          process.env.VUE_APP_API_CHECK_AUTOREPLY +
            '/getbotmessagereply/' +
            this.$route.params.id
        )
        .then((response) => {
          // console.log(response)
          if (response.data.message === 'success') {
            const { message, businessdays } = response.data.result[0]
            // this.list_date_reply = response.data.result[0].businessdays
            const tableDatas = message.map((item) => {
              const obj = {
                message: item.message,
                createddate: item.createddate
              }

              return obj
            })

            const lastIndex = tableDatas.length - 1
            if (lastIndex >= 0) {
              tableDatas[lastIndex].businessdays = businessdays.sort((a, b) => a.day - b.day)
            }
            this.list_messsage_reply = tableDatas
            this.list_messsage_reply = [_.last(this.list_messsage_reply)]
            // console.log(this.list_messsage_reply)
            // console.log(_.last(this.list_messsage_reply))
          }
        })
    },
    formatDate (isoDate) {
      var dateFormat = new Date(isoDate)
      var dd = String(dateFormat.getDate()).padStart(2, '0')
      var mm = String(dateFormat.getMonth() + 1).padStart(2, '0') // january is 0
      var yyyy = dateFormat.getFullYear()
      dateFormat = dd + '/' + mm + '/' + yyyy

      return dateFormat
    },
    formatTime (date) {
      const hour = date.getHours().toString().padStart(2, '0')
      const minute = date.getMinutes().toString().padStart(2, '0')

      return `${hour}:${minute}:00`
    }
  }
}
</script>

<style scoped>
>>> .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  /* padding-right: 12px; */
  /*font-size: 14px;*/
  font-size: 14px;
  resize: none;
  height: 75px !important;
}
>>> .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  height: 100px !important;
  border-radius: 20px !important;
  width: 100% !important;
  border-style: solid !important;
  border-color: #c1c1c1 !important;
  box-shadow: none !important;
  border-width: thin !important;
}
>>> .v-text-field > .v-input__control > .v-input__slot {
  border: transparent !important;
}
/* >>>.theme--light.v-table thead tr:first-child {
    border-bottom: 1px solid rgba(0,0,0,0.12);
    background-color: #607D8B;
}
>>>.theme--light.v-table thead th {
    color: white;
    font-size: 16px !important;
} */
.textSend {
  font-size: 18px;
  padding-bottom: 10px;
}
.Everyday {
  text-align: left;
  font-size: 16px;
  padding-bottom: 20px;
}
.box {
  text-align: left;
  font-size: 16px;
  padding-bottom: 20px;
}
.scrolling-wrapper {
  /* display: flex; */
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 2px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.1);
}
</style>
